export default __webpack_public_path__ + "static/media/telehealth-avenir-next.c6493abe.woff2";